exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.prime-box{\r\n    background-color:rgba(180, 116, 0, 0.8);\r\n    border: 2px solid white;\r\n    cursor: pointer;\r\n    width: 17vw;\r\n    text-align: center;\r\n    height: 22vh;\n}\n.icon-container{\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 30%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n            transform: translate(-50%, -50%);\r\n    width: 100%;\r\n    padding: 20px 10px 20px 10px;\r\n    text-align: center;\n}\n.services-p{\r\n    font-size: 1.2em !important;\r\n    font-weight: bold !important;\r\n    color: white;\n}\n.services-p2{\r\n    font-size: 0.9em;\r\n    font-weight: normal;\r\n    margin-top: 15px;\r\n    color: white;\n}\r\n\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b114648","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/patient/GoOpensaludpass.vue
// module id = 2101
// module chunks = 116